import { Button, Dialog, Grid, Icon, Typography, Select, Tooltip, FormHelperText } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { Label } from '../../../../../../components/UiElements/UiElements'
import { InputBaseField } from '../../../../../../components/InputField/InputField'
import { PostDataAPI } from '../../../../../../Services/APIService';
import Loader from './../../../../../../components/Loader/Loader';
import { handleNumberKeyPress, maskAccountNumber, maskCreditCardNumber, saveActivlityLogInfo } from '../../../../../../../src/components/Common/Extensions';
import { withSnackbar } from "./../../../../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths } from '../../../../../../../src/components/Common/Lookup';
import axios from 'axios';
import { GetUserInfo } from "../../../../../../Services/GetUserInfo";
import ChangeShippingAddress from '../../../../../prepaid/components/changeShippingAddress/ChangeShippingAddress';

import useStyles from "./styles";
function CarrierInformation({ handleNext, triggerCarrierInformation, updateTrigger, msisdn, data, isPrepaid, simPrice, setLoaderVisible, customerData, updateBillingInfo,
    setLoaderHide, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    let user_info = JSON.parse(GetUserInfo());
    const [customerInfo, setCustomerInfo] = useState(customerData ? customerData : {});
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    data.msisdn = data.msisdn ? data.msisdn.toString() : '';
    const [state, setState] = useState(data);
    const [wirelessPlans, setWirelessPlans] = useState([]);
    const [carriersList, setCarriersList] = useState([
        { label: 'Please select existing carrier', value: '' },
        { label: 'AT&T', value: 'AT&T' },
        { label: 'Sprint', value: 'Sprint' },
        { label: 'TMobile', value: 'TMobile' },
        { label: 'Verizon', value: 'Verizon' },
        { label: 'Other', value: 'Other' }
    ]);
    const [planTypes, setPlanTypes] = useState([
        { label: 'Please select plan type', value: '' },
        { label: 'Text And Type', value: 'Text And Type' },
        { label: 'Economical', value: 'Economical' },
        { label: 'Unlimited Plan', value: 'Unlimited Plan' },
        { label: 'Family Plan', value: 'Family Plan' }
    ]);
    const [errorMessages, setErrorMessages] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
    }

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleCardChange = (event) => {
        let value = event.target.value.replace(/\D/g, ''); // remove non-numeric characters
        const { name } = event.target;

        if (value.length <= 16) {
            value = value.match(/.{1,4}/g)?.join('-') || ''; // add - space after every 4 digits
        } else {
            value = state.creditCardNumber; // ignore input if it exceeds 16 digits
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };
    const getStateAndCityOnZipCodeChange = (name, zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);
                    if (name == 'shipZip') {
                        setState(prevState => ({
                            ...prevState,
                            ['shipState']: state_abbreviation,
                            ['shipCity']: place_name
                        }))
                    }

                }
            })
            .catch((error) => {
                console.log('Error fetching location data:', error);
            });
    };


    const PortNumber = () => {
        let errorList = [];

        Validate(errorList);
        if (errorList.length < 1) {
            setLoaderVisible();
            state.creditCardExpiration = state.ccExpMonth + '/' + state.ccExpYear;
            handleNext(state);
            setTimeout(() => {
                setLoaderHide();
            }, 500)
        }

    }
    const Validate = (errorList) => {
        if (!state.existingCarrier) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorExistingCarrier: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorExistingCarrier: false
            }));
        }

        if (state.existingCarrier && state.existingCarrier == 'Other') {
            if (!state.otherCarrier) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorOtherCarrier: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorOtherCarrier: false
                }));
            }

        }
        if (!state.oldCarrierAccountNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAccountNumber: true,
                errorAccountNumberLength: false
            }));
            errorList.push(true);
        } else if (state.oldCarrierAccountNumber.length < 8) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAccountNumber: false,
                errorAccountNumberLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAccountNumber: false,
                errorAccountNumberLength: false
            }));
        }

        if (!state.transferPin) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNumberTransferPin: true,
                errorTransferPinLength: false
            }));
            errorList.push(true);
        } else if (state.transferPin.length < 4) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNumberTransferPin: false,
                errorTransferPinLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNumberTransferPin: false,
                errorTransferPinLength: false
            }));
        }

        if (!state.ssn) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSsn: true,
                errorSsnLength: false
            }));
            errorList.push(true);
        } else if (state.ssn.length < 4) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSsn: false,
                errorSsnLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSsn: false,
                errorSsnLength: false
            }));
        }

        if (!state.imei) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: true,
                errorImeiLength: false
            }));
            errorList.push(true);
        }else if (state.imei.length < 8) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: false,
                errorImeiLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: false,
                errorImeiLength: false
            }));
        }


        if (!state.zip) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: true,
                errorZipCodeLength: false
            }));
            errorList.push(true);
        } else if (state.zip.length < 5) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: false,
                errorZipCodeLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: false,
                errorZipCodeLength: false
            }));
        }

        if (isPrepaid) {
            debugger;
            if (!customerInfo?.creditCardNumber) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardNumber: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardNumber: false
                }));
            }

            //if (!validateCreditCardExpiry()) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCardExpiration: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCardExpiration: false
            //    }));
            //}

            //if (!state.creditCardNumber) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCardNumber: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCardNumber: false
            //    }));
            //}

            //const newCreditCardNumber = state.creditCardNumber ? state.creditCardNumber.replace(/\*/g, '') : '';
            //if (newCreditCardNumber && newCreditCardNumber.length != 19) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorInvalidCardNumber: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorInvalidCardNumber: false
            //    }));
            //}

            //if (!state.nameOnCard) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorNameOnCard: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorNameOnCard: false
            //    }));
            //}
            //if (!state.cvc) {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCvc: true
            //    }));
            //    errorList.push(true);
            //}
            //else {
            //    setErrorMessages(prevState => ({
            //        ...prevState,
            //        errorCvc: false
            //    }));
            //}
        }


    }
    const validateCreditCardExpiry = () => {
        if (!state.ccExpMonth || !state.ccExpYear || isNaN(state.ccExpMonth) || isNaN(state.ccExpYear))
            return false;
        if (state.ccExpMonth < 1 || state.ccExpMonth > 12)
            return false;
        if (state.ccExpYear < new Date().getFullYear().toString())
            return false;

        return true;

    }

    const handleChangeBillingSuccessClose = (_updateBillingInfo) => {
        showMessage("Success", "Billing information updated successfully", "success", 3000);

        setCustomerInfo(prevState => ({
            ...prevState,
            billingAddress1: _updateBillingInfo.address1,
            billingAddress2: _updateBillingInfo.address2,
            billingCity: _updateBillingInfo.city,
            billingState: _updateBillingInfo.state,
            billingZip: _updateBillingInfo.zip,
            billingName: _updateBillingInfo.billingName,
            cardNumber: _updateBillingInfo.creditCardNumber,
            creditCardExpiration: _updateBillingInfo.ccExpMonth + '/' + _updateBillingInfo.ccExpYear,
            creditCardNumber: _updateBillingInfo.creditCardNumber,
            creditCardType: _updateBillingInfo.creditCardType,
            creditCardExpirationCvv: _updateBillingInfo.creditCardExpirationCvv

        }));
        updateBillingInfo(_updateBillingInfo);
        setChangeBillingAddress(false)
    }

    const [objAddress, setObjAddress] = useState({});
    const [changeBillingAddress, setChangeBillingAddress] = useState(false);
    const changePaymentInfoAddress = () => {
        saveActivlityLogInfo(
            "Line Management",
            "Port In Payment Information Dialog Opened",
            `User opened payment information update dialog from Port In flow for account ${maskAccountNumber(accountNumber)}`,
            accountNumber,
            customerID
        );

        setObjAddress({
            address1: customerInfo?.billingAddress1,
            address2: customerInfo?.billingAddress2,
            city: customerInfo?.billingCity,
            state: customerInfo?.billingState,
            zip: customerInfo?.billingZip,
            billingName: customerInfo?.billingName,
            creditCardNumber: customerInfo?.creditCardNumber,
            creditCardType: customerInfo?.creditCardType,
            creditCardExpiration: customerInfo?.creditCardExpiration,
            creditCardExpirationCvv: customerInfo?.creditCardExpirationCvv,
        });
        setChangeBillingAddress(true);

    }

    useEffect(() => {
        console.log(customerInfo)
        console.log(data);
        if (triggerCarrierInformation) {
            PortNumber();
            updateTrigger();
        }
    }, [triggerCarrierInformation]);
    return (
        <>

            <Grid container style={{ justifyContent: 'center', textAlign: 'center' }}>
                <Grid item>
                    <h1 style={{ color: '#10B921' }}>Congratulations</h1>
                    <h3>Your Number <b>{msisdn}</b> is Portable</h3>
                </Grid>
            </Grid>

            <Grid container alignItems='center'>
                <Grid item lg={12} sm={12} xs={12}>
                    <Grid container>
                        <div className={classes.dialogSubHeader}>
                            <h3>Existing Carrier Information</h3>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid lg={12} sm={12} xs={12}>
                    <Grid container spacing={window.isMobileView? 0: 4}>
                        <Grid item sm={12} xs={12} md={state.existingCarrier == 'Other' ? 3 : 6} lg={state.existingCarrier == 'Other' ? 3 : 6} xl={state.existingCarrier == 'Other' ? 3 : 6} >
                            <Label title="Existing Carrier" size={12} mandatory={true} />
                            <Grid sm={12} md={12} lg={12} xl={12}>
                                <Select
                                    size="small"
                                    native
                                    name="existingCarrier"
                                    value={state.existingCarrier}
                                    onChange={handleChange}
                                    placeholder="Select"
                                    label="Select"
                                    className={classes.selectBaseInput}
                                >
                                    {carriersList.map(option =>
                                        <option value={option.value}>{option.label}</option>
                                    )
                                    }
                                </Select>
                                {errorMessages.errorExistingCarrier && !state.existingCarrier ? (<FormHelperText style={{ color: "red" }} >
                                    Please select existing carrier
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                        {state.existingCarrier == 'Other' ?
                            <>
                                <Grid item sm={12} xs={12} md={3} lg={3} xl={3} >
                                    <Label title="Other Carrier" size={12} mandatory={true} />
                                    <InputBaseField
                                        id="otherCarrier"
                                        name="otherCarrier"
                                        type="text"
                                        value={state.otherCarrier}
                                        onChange={handleChange}
                                        placeholder='Other Carrier'
                                        IsDisabled={false}
                                        MaxLength='50'
                                    />
                                    {errorMessages.errorOtherCarrier && state.existingCarrier == 'Other' && !state.otherCarrier ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter other carrier
                                    </FormHelperText>) : ('')}
                                </Grid>
                            </>
                            : ''

                        }

                    </Grid>
                    <Grid container spacing={window.isMobileView? 0: 4}>

                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="Account Number" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="oldCarrierAccountNumber"
                                    name="oldCarrierAccountNumber"
                                    type="text"
                                    value={state.oldCarrierAccountNumber}
                                    onChange={handleChange}
                                    placeholder='Account Number'
                                    IsDisabled={false}
                                    MaxLength='14'
                                    MinLength='8'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorAccountNumber && !state.oldCarrierAccountNumber ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter account number
                                </FormHelperText>) : ('')}
                                {errorMessages.errorAccountNumberLength && state.oldCarrierAccountNumber.length > 0 && state.oldCarrierAccountNumber.length < 8 && (
                                    <FormHelperText style={{ color: "red" }}>
                                         Account number must be atleast 8 characters
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="Number Transfer Pin" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="transferPin"
                                    name="transferPin"
                                    type="text"
                                    value={state.transferPin}
                                    onChange={handleChange}
                                    placeholder='Number Transfer Pin'
                                    IsDisabled={false}
                                    MaxLength='14'
                                    MinLength='4'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorNumberTransferPin && !state.transferPin ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter transfer pin
                                </FormHelperText>) : ('')}
                                {errorMessages.errorTransferPinLength && state.transferPin.length > 0 && state.transferPin.length < 4 && (
                                    <FormHelperText style={{ color: "red" }}>
                                        Transfer pin must be atleast 4 characters
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={window.isMobileView? 0: 4}>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="SSN (Last Four Digits)" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="ssn"
                                    name="ssn"
                                    type="text"
                                    value={state.ssn}
                                    onChange={handleChange}
                                    placeholder='SSN'
                                    IsDisabled={false}
                                    MaxLength='4'
                                    MinLength='4'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorSsn && !state.ssn ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter SSN
                                </FormHelperText>) : ('')}
                                {errorMessages.errorSsnLength && state.ssn.length > 0 && state.ssn.length < 4 && (
                                    <FormHelperText style={{ color: "red" }}>
                                        SSN must be 4 characters
                                    </FormHelperText>
                                )}
                                
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="IMEI / Device Serial Number" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="imei"
                                    name="imei"
                                    type="text"
                                    value={state.imei}
                                    onChange={handleChange}
                                    placeholder='IMEI'
                                    IsDisabled={false}
                                    MaxLength='14'
                                    MinLength='8'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorImei && !state.imei ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter IMEI number
                                </FormHelperText>) : ('')}
                                {errorMessages.errorImeiLength && state.imei.length > 0 && state.imei.length < 8 && (
                                    <FormHelperText style={{ color: "red" }}>
                                        IMEI number must be atleast 8 characters
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="ZIP / Postal Code" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    value={state.zip}
                                    onChange={handleChange}
                                    placeholder='ZIP / Postal Code'
                                    IsDisabled={false}
                                    MaxLength='5'
                                    MinLength='5'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorZipCode && !state.zip ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter ZIP / Postal Code
                                </FormHelperText>) : ('')}
                                {errorMessages.errorZipCodeLength && state.zip.length > 0 && state.zip.length < 5 && (
                                    <FormHelperText style={{ color: "red" }}>
                                        ZIP / Postal Code must be 5 characters
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {isPrepaid ?
                    <>
                        <Grid container spacing={2}>
                            <h4 className={classes.secHeading}>Payment Information  </h4>
                        </Grid>

                        <Grid lg={12} sm={12} xs={12}>
                            <Grid container spacing={window.isMobileView? 0: 4}>
                                <Grid item sm={12} xs={12} md={8} lg={8} xl={8} >
                                    <Label size={12} title="Debit /Credit Card Number" mandatory={true} />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={8} md={8} lg={8} xl={8} >
                                                <InputBaseField
                                                    id="creditCardNumber"
                                                    name="creditCardNumber"
                                                    type="text"
                                                    value={maskCreditCardNumber(customerInfo?.creditCardNumber)}
                                                    placeholder='Debit /Credit Card Number'
                                                    IsDisabled={true}
                                                    MaxLength='14'
                                                />
                                                {errorMessages.errorCardNumber && !customerInfo?.creditCardNumber ? (<FormHelperText style={{ color: "red" }} >
                                                    Please add payment information
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{ textAlign: 'left' }}>
                                                <Button className={classes.changeBtn} onClick={changePaymentInfoAddress}>Update</Button>
                                            </Grid>
                                        </Grid>

                                    </Grid>




                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                    :
                    ''}
            </Grid>

            {
                changeBillingAddress ?
                    <ChangeShippingAddress
                        dialogOpenClose={changeBillingAddress}
                        handleClose={() => { setChangeBillingAddress(false) }}
                        handleSuccessClose={handleChangeBillingSuccessClose}
                        addressType={'updateBillingAddress'}
                        objAddress={objAddress}
                        accountNumber={accountNumber}
                    ></ChangeShippingAddress>
                    : null
            }
        </>
    )
}
export default withSnackbar(CarrierInformation);
